import { render, staticRenderFns } from "./TestPdfView.vue?vue&type=template&id=2e38380d&scoped=true"
import script from "./TestPdfView.vue?vue&type=script&lang=js"
export * from "./TestPdfView.vue?vue&type=script&lang=js"
import style0 from "./TestPdfView.vue?vue&type=style&index=0&id=2e38380d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38380d",
  null
  
)

export default component.exports